import styled from '@emotion/styled-base';
import React from 'react';

import { SocialMediaLinkContent } from '../../models/app-data-model';
import ShIcon from '../sh-icon/sh-icon';
import ShLink from '../sh-link/sh-link';
import './social-media-buttons.scss';

export type SocialMediaButtonsProps = {
  socials: SocialMediaLinkContent[];
  className?: string;
  horizontalAlignment?: 'left' | 'center' | 'right';
};

const SocialMediaButtons: React.FC<SocialMediaButtonsProps> = ({ socials, className }: SocialMediaButtonsProps) => {
  /**
   * Social Media Buttons Component
   * Dynamically renders Social Media Buttons based on Global Footer Social Media Links Content
   * @returns
   */
  const socialMediaButtons = (
    <div data-testid="social-media-buttons" className={`social-media-buttons ${className}`}>
      {socials?.map((item, index) => {
        // adding units to the end of our dynamic css below will break unsanitized inputs and protect us from css-injection
        // so CSS.escape is not needed here.
        const StyledShIcon = styled(ShIcon)`
          width: ${item.svg_icon.width.toString()}px;
          height: ${item.svg_icon.height.toString()}px;
        `;

        return (
          <ShLink reference={item.reference} key={index} dataTestId={`social-media-button-${item.title}`}>
            <StyledShIcon icon={item.svg_icon} className={`smb-icon ${item.title?.toLowerCase()}`} altText={item.alt_text} />
          </ShLink>
        );
      })}
    </div>
  );
  return socialMediaButtons;
};

/**
 * Social Media Buttons Component
 * Dynamically renders Social Media Buttons based on Global Footer Social Media Links Content
 * @returns
 */
const StyledSocialMediaButtons: React.FC<SocialMediaButtonsProps> = styled(SocialMediaButtons)`
  justify-content: ${(props) => CSS.escape(props.horizontalAlignment || '')};
`;

export default StyledSocialMediaButtons;
